import { Check2 } from 'react-bootstrap-icons';
import { Stack } from 'react-bootstrap';
import { IntLi } from '.';

export default function InterrogatoriesNavigator({
  intData,
  onClick,
  refsDone,
  selectedInterrogatories,
  documentStartingNumber,
}: {
  intData: IntLi[];
  onClick: (target: string) => void;
  refsDone: boolean;
  selectedInterrogatories: Set<number>;
  documentStartingNumber: number;
}) {
  if (!refsDone) {
    return <></>;
  }

  return (
    <div className="interrogatory-response-grid">
      {intData.map((item) => (
        <Stack key={item.id} direction="vertical" className="position-relative pb-3 align-items-center">
          <button
            className={`interrogatory-number rounded-circle fs-7 d-flex justify-content-center align-items-center ${
              selectedInterrogatories.has(item.id) ? 'border-success text-success' : ''
            }`}
            onClick={() => {
              onClick((documentStartingNumber - 1 + Number(item.number ?? 1)).toString());
            }}
          >
            {documentStartingNumber - 1 + Number(item.number ?? 1)}
          </button>
          {selectedInterrogatories.has(item.id) && (
            <Check2 className="text-success position-absolute bottom-0" />
          )}
        </Stack>
      ))}
    </div>
  );
}
